module.exports = __webpack_public_path__ + "static/media/cbse_approved.22345b51.jpg";